export enum ReportedType {

  /**
   * Did not purchase.
   */
  DNP,

  /**
   * Purchase.
   */
  P,

  /**
   * Purchase AQ.
   */
  PAQ

}

export namespace ReportedType {

  export function fromString(name: string): ReportedType {
    return ReportedType[name];
  }

}

